import { Theme } from '@mui/system'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  bigContainer: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    flexWrap: 'wrap',
    padding: `${SPACES.xs} ${SPACES.xxl} ${SPACES.xxl}`,

    [theme.breakpoints.down('tablet')]: {
      width: '100%',
      height: 'auto',

      border: `1px solid ${theme.palette.custom.grey}`,
      borderRadius: 10,
    },

    [theme.breakpoints.up('tablet')]: {
      border: `1px solid ${theme.palette.custom.grey}`,
      borderRadius: 15,

      minWidth: 335,
    },
  },
  selectionList: {
    '&&': {
      maxWidth: '100%',
      height: '100%',
    },
  },
  selectionsWrapper: {
    '&&': {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',

      [theme.breakpoints.down('tablet')]: {
        rowGap: SPACES.xs,
      },
      [theme.breakpoints.up('tablet')]: {
        rowGap: SPACES.xxl,
      },
    },
  },
  text: {
    fontWeight: FONTS.WEIGHTS.medium,
    color: theme.palette.custom.grey2,
    marginBottom: SPACES.xxxs,

    [theme.breakpoints.down('tablet')]: {
      fontSize: FONTS.SIZES.s,
    },
    [theme.breakpoints.up('tablet')]: {
      fontSize: FONTS.SIZES.xs,
    },
  },
  container: {
    '&&': {
      display: 'flex',
      alignItems: 'center',

      [theme.breakpoints.up('tablet')]: {
        padding: `${SPACES.xl}`,
        width: 370,
        height: 60,

        border: `1px solid ${theme.palette.custom.grey}`,
        borderRadius: 15,
      },
    },
  },
  label: {
    '&&': {
      paddingTop: SPACES.xs,
      paddingLeft: SPACES.xxl,
      marginBottom: SPACES.xxxs,

      lineHeight: 1.4,

      [theme.breakpoints.down('laptop')]: {
        fontSize: FONTS.SIZES.s,
        fontWeight: FONTS.WEIGHTS.light,
      },
      [theme.breakpoints.up('tablet')]: {
        fontSize: FONTS.SIZES.m,
        fontWeight: FONTS.WEIGHTS.medium,
      },
    },
  },
  iconWrapper: {
    minWidth: 42,
    display: 'flex',
  },
  input: {
    '&&': {
      height: 19,

      border: 'none',
      backgroundColor: theme.palette.custom.white,

      whiteSpace: 'pre-wrap',
      wordWrap: 'break-word',
      fontSize: FONTS.SIZES.m,
      color: theme.palette.custom.darkBlue2,

      '&:focus': {
        outline: 'none',
      },

      [theme.breakpoints.down('tablet')]: {
        padding: 0,
        '&:placeholder': {
          color: theme.palette.custom.grey2,
        },
      },
      [theme.breakpoints.up('tablet')]: {
        padding: 0,

        '&:placeholder': {
          color: theme.palette.custom.grey,
        },
      },
    },
  },
}))
